export default __webpack_public_path__ + "static/labs-6da8f49d60bc038d3403f70e211db0a4.png";